import { Record } from 'immutable'

const SelectRecord = Record({
  value: '',
  label: '',
})

export default class Select extends SelectRecord {}
